import { render, staticRenderFns } from "./batch_import_associations.vue?vue&type=template&id=fa69c58e&"
import script from "./batch_import_associations.vue?vue&type=script&lang=js&"
export * from "./batch_import_associations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports